module.exports = __webpack_public_path__ + "img/934-505e48.png";